import React, { useState } from 'react';
import { Card, CardMedia, CardContent, Typography, Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export default () => {
  const { width } = useWindowDimensions();
  const fontSize = width <= 500 ? '3vw' : '15px';
  const debugLog = useSelector(state => state.tasks.debugLog);
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setOpen(!open)}
        variant="contained"
        style={{
          fontSize,
          margin: '2px',
          marginTop: '5px',
        }}
      >
        {open ? 'Затвори debug log' : 'Отвори debug log'}
      </Button>
      {open &&
        debugLog.map(x => (
          <Card key={debugLog.indexOf(x)}>
            <CardMedia>
              <div
                style={{
                  backgroundColor: 'red',
                  padding: '3px',
                  color: 'white',
                }}
              >
                {x.title}
              </div>
            </CardMedia>
            <CardContent>
              <Typography gutterBottom component="h2" style={{ fontSize, wordBreak: 'break-word' }}>
                {x.logMessage}
              </Typography>
            </CardContent>
          </Card>
        ))}
      {open && debugLog.length === 0 && (
        <div
          style={{
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          Няма записи
        </div>
      )}
    </>
  );
};
